import axios from "axios";
import globalStore from "@/utils/global-store";
import apiConfig from "@/config/api";

export const apiClient = axios.create({
    baseURL: apiConfig.baseUrl,
    withCredentials: true, // required to handle the CSRF token
});

/*
 * Add a response interceptor
 */
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if( error.response && [401, 419].includes(error.response.status) ) {
            console.warn('api returned 401/419 => not authenticated');
            globalStore.unauthenticatedResponseReceived();
        }
        return Promise.reject(error);
    }
);
